<template>
    <div>
        <Heading title="Vielen Dank für Dein Vertrauen!" :size="2" />
        <Heading title="Wie geht es weiter?" :size="3" />
        <info-snippet icon="CounterOneIcon" coloredIcon>
            Dein lokaler Reiseexperte meldet sich in Kürze bei Dir.
        </info-snippet>
        <info-snippet icon="CounterTwoIcon" coloredIcon>
            Gemeinsam plant Ihr Deine Traumreise. Deine Wünsche kannst Du auch telefonisch besprechen.
        </info-snippet>
        <info-snippet icon="CounterThreeIcon" coloredIcon>
            Sichere Buchung & Bezahlung Deiner Pauschalreise - vollständig abgesichert.
        </info-snippet>
        <custom-button @click="loadHomepage()">
            Zurück zur Startseite &rarr;
        </custom-button>

    </div>
</template>

<script>
import CustomButton from "../components/baseComponents/CustomButton.vue";
import InfoSnippet from "../components/travelDataComponents/InfoSnippet.vue";

export default {
    name: 'SuccessPage',
    components: {InfoSnippet, CustomButton},
    methods: {
        loadHomepage() {
            document.location.href = '/';
        },
    },
    mounted() {
        this.$store.commit('tour/setPending', false);
    }
}

</script>

<style scoped>

</style>